import React from 'react';
import { motion } from 'framer-motion';
interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  alignment?: 'left' | 'center';
  className?: string;
  light?: boolean;
  withLines?: boolean;
}
export function SectionHeading({
  title,
  subtitle,
  alignment = 'center',
  className = '',
  light = false,
  withLines = false
}: SectionHeadingProps) {
  return <div className={`mb-12 ${alignment === 'center' ? 'text-center' : 'text-left'} ${className}`} data-id="element-240">
      {subtitle && <motion.span initial={{
      opacity: 0,
      y: 10
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5
    }} className={`block text-sm font-bold tracking-widest uppercase mb-3 ${light ? 'text-[#C8102E]' : 'text-[#C8102E]'}`} data-id="element-241">
          {subtitle}
        </motion.span>}

      {withLines ? <div className={`flex items-center ${alignment === 'center' ? 'justify-center' : 'justify-start'} gap-3 md:gap-6`} data-id="element-242">
          <motion.div initial={{
        scaleX: 0
      }} whileInView={{
        scaleX: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className={`h-[1px] w-8 sm:w-16 md:w-24 shrink-0 ${light ? 'bg-white/30' : 'bg-[#C8102E]'}`} data-id="element-243" />
          <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className={`text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-serif font-bold uppercase tracking-wide text-center ${light ? 'text-white' : 'text-[#0A1F44]'}`} data-id="element-244">
            {title}
          </motion.h2>
          <motion.div initial={{
        scaleX: 0
      }} whileInView={{
        scaleX: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className={`h-[1px] w-8 sm:w-16 md:w-24 shrink-0 ${light ? 'bg-white/30' : 'bg-[#C8102E]'}`} data-id="element-245" />
        </div> : <>
          <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className={`text-3xl md:text-4xl lg:text-5xl font-serif font-bold uppercase tracking-wide ${light ? 'text-white' : 'text-[#0A1F44]'}`} data-id="element-246">
            {title}
          </motion.h2>
          <motion.div initial={{
        opacity: 0,
        scaleX: 0
      }} whileInView={{
        opacity: 1,
        scaleX: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className={`h-1 w-20 mt-6 ${alignment === 'center' ? 'mx-auto' : ''} bg-[#C8102E]`} data-id="element-247" />
        </>}
    </div>;
}